import { render, staticRenderFns } from "./SectionDivider.vue?vue&type=template&id=fef0864e&scoped=true&"
import script from "./SectionDivider.vue?vue&type=script&lang=js&"
export * from "./SectionDivider.vue?vue&type=script&lang=js&"
import style0 from "./SectionDivider.vue?vue&type=style&index=0&id=fef0864e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef0864e",
  null
  
)

export default component.exports